import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ConnectivityService } from "src/app/core/services/connectivity.service";
import { LoggerService } from "src/app/core/services/logger.service";

@Component({
  selector: 'app-reconnect',
  templateUrl: './reconnect.component.html',
  styleUrls: ['./reconnect.component.scss']
})
export class ReconnectComponent implements OnInit {

  constructor(
    private router: Router,
    private connectivityService: ConnectivityService,
  ) {}

  ngOnInit(): void {
    this.connectivityService.isConnected$.subscribe((status) => {
      if (status.isOnline) {
        this.redirectAndReloadPage();
      }
    });
  }

  onClickReloadPage() {
    this.redirectAndReloadPage();
  }

  redirectAndReloadPage() {
    this.router.navigate(['']);

    setTimeout(() => {
      window.location.reload();
    }, 500)
  }
}
